export default function getUpdatedPayments(payment, order = {}) {
  const found = order.payments.find(p => p.id === payment.id)

  // We don't want a duplicate payment for submit retries due to sync failures.
  // More description in components/checkout/CheckoutPaymentForm/index.
  if (found !== undefined) return order.payments
  else return [...order.payments, payment]
}
